import Switch from "rc-switch";
import Button from "../../components/Buttons/Button";
import React, { useCallback, useEffect, useState } from "react";
import { useApi } from "../../hooks/api";
import { Column, Line } from "../../style";
import { FaEdit, FaWhatsapp } from "react-icons/fa";
import { io, Socket } from "socket.io-client";
import { BiCheckCircle } from "react-icons/bi";
import { useGlobal } from "../../hooks/global";
import { TbPlugConnected } from "react-icons/tb";
import { inactiveItens, secondary } from "../../theme";
import { HeaderList } from "../../components/HeaderList";
import { DashboardPage } from "../../components/DashboardPage/index";
import { ModalLoading } from "../../components/Loadings/ModalLoading";
import { IntegrationsTypes, IIntegrationsProps } from "../../interfaces";
import { ContentOrLoading } from "../../components/Loadings/ContentOrLoading";
import { ContainerIntegrationLogo, ContainerIntegrations, IntegrationContainer, IntegrationDescription, SwitchContainer } from "./style";
import staysIcon from "./../../assets/stays.svg";
import magikeyIcon from "./../../assets/magikey.svg";
import { ModalWppConection } from "./ModalWppConection";
import { DropdownButton } from "../../components/Buttons/DropdownButton";
import { ModalMagikeyConection } from "./ModalMagikeyConection";
import { ModalStaysConection } from "./ModalStaysConection";
import { ModalDeleteStaysConection } from "./ModalDeleteStaysConection";
import { useWallet } from "../../hooks/wallet";

interface IIntegrationsAvailblesProps {
    name: IntegrationsTypes;
    title: string;
    description: string;
    icon: { dark: any; light: any; }
}

const correct_names: any = {
    wpp: { name: "Whatsapp", predicate: "o" },
}

const integrationsAvailbles: IIntegrationsAvailblesProps[] = [
    {
        name: "stays",
        title: "Stays",
        description: "Software que permite a automatização de todas as áreas de um negócio de aluguel por temporada.",
        icon: {
            dark: <img src={staysIcon} alt="Stays" style={{ width: 30, objectFit: "contain" }} />,
            light: <img src={staysIcon} alt="Stays" style={{ width: 30, objectFit: "contain" }} />
        }
    },
    {
        name: "wpp",
        title: "Whatsapp",
        description: "Utilize o WhatsApp Messenger para automatizar a comunicação com seus hóspedes.",
        icon: {
            dark: <FaWhatsapp size={30} color={"green"} />,
            light: <FaWhatsapp size={30} color={"green"} />
        }
    },
    {
        name: "magikey",
        title: "MagiKey",
        description: "Software para controle de acesso e gestão de fechaduras eletrônicos aliando segurança e usabilidade.",
        icon: {
            dark: <img src={magikeyIcon} alt="Stays" style={{ width: 30, objectFit: "contain" }} />,
            light: <img src={magikeyIcon} alt="Stays" style={{ width: 30, objectFit: "contain" }} />
        }
    }
];

export const IntegrationsList: React.FC = () => {
    const { api, setUser, user } = useApi()
    const { theme, notify } = useGlobal()
    const { subscription } = useWallet();

    const [loadingEdit, setLoadingEdit] = useState(false)
    const [loadingSearch, setLoadingSearch] = useState(true)
    const [editIntegration, setEditIntegration] = useState<IntegrationsTypes | null>(null)
    const [isModalDeleteStays, setIsModalDeleteStays] = useState(false)
    const [integrationsTokens, setIntegrationsTokens] = useState<IIntegrationsProps>({ wpp: {} } as IIntegrationsProps)
    const [verifyWppConectingStatus, setVerifyWppConectingStatus] = useState(false)

    const isHaveWppPermission = subscription ? subscription?.plans?.permissions.includes("WHATSAPP_INTEGRATION") : true;
    const isHaveMagikeyPermission = subscription ? subscription?.plans?.permissions.includes("ELECTRONIC_LOCKS_INTEGRATION") : true;

    const handleChangeStatus = useCallback(async (type: 'wpp') => {
        const result = window.confirm(`Tem certeza que deseja ${validate(integrationsTokens[type]) ? "desconectar" : "conectar"} a integração com ${correct_names[type].predicate} ${correct_names[type].name}?`)
        if (result) await handleConfirm(type)
    }, [integrationsTokens])

    const handleConfirm = useCallback(async (type: IntegrationsTypes) => {
        setLoadingEdit(true)

        try {
            await api.delete("/integrations")

            notify(`Integração encerrada com ${correct_names[type].predicate} ${correct_names[type].name}`, "success")

            searchIntegrationsTokens()
        } catch (error) {
            notify(`Erro ao encerrar a integração com ${correct_names[type].predicate} ${correct_names[type].name}`, "error")
        }

        setLoadingEdit(false)

    }, [integrationsTokens])

    const handleUpdateActiveIntegrationMagikey = useCallback(async () => {
        setLoadingEdit(true);

        try {
            const activeAtual = integrationsTokens['magikey']?.active;

            await api.put(`/integrations`, {
                active: !activeAtual,
                id: integrationsTokens['magikey'].integrationId
            })

            const message = activeAtual ? 'desativada' : 'ativada';

            notify(`Integração com Magikey ${message}`, "success");
        } catch (err) {
            notify("Erro ao mudar status da integração com Magikey", "error")
        }

        setLoadingEdit(false);
    }, [integrationsTokens, setIntegrationsTokens])

    const handleDeleteIntegrationMagikey = useCallback(async () => {
        setLoadingEdit(true);

        try {
            await api.delete(`/integrations/${integrationsTokens['magikey'].integrationId}`)

            notify(`Integração com Magikey desconectada!`, "success");
        } catch (err) {
            notify("Erro ao desconectar integração com Magikey", "error")
        }

        setLoadingEdit(false);

        searchIntegrationsTokens();
    }, [integrationsTokens, setIntegrationsTokens])

    const handleDeleteIntegrationStays = useCallback(async () => {
        setLoadingEdit(true);

        try {
            await api.delete(`/integrations/${integrationsTokens['stays'].integrationId}?type=stays`)

            notify(`Integração com Stays desconectada!`, "success");
        } catch (err) {
            notify("Erro ao desconectar integração com Stays", "error")
        }

        setLoadingEdit(false);
        setIsModalDeleteStays(false);

        setUser({ ...user, integration_stays_active: false })

        searchIntegrationsTokens();
    }, [integrationsTokens, setIntegrationsTokens])

    const searchIntegrationsTokens = useCallback(async (is_wpp = true) => {
        // is_wpp, se vai trazer wpp junto ou nao,
        setEditIntegration(null)

        setLoadingSearch(true)

        try {
            const { data } = await api.get(`/integrations?is_wpp=${is_wpp}`);

            if (is_wpp) {
                setIntegrationsTokens(data)
            } else {
                setIntegrationsTokens({
                    magikey: data?.magikey,
                    stays: data?.stays,
                    wpp: {
                        instance: '',
                        status: 'connecting',
                    }
                })
            }

        } catch (err) {
            notify("Erro ao buscar as integrações", "error")
        }

        setLoadingSearch(false)
    }, [])

    const handleConectIntegration = useCallback(async (type: IntegrationsTypes) => {
        setEditIntegration(type)
    }, [])

    const handleSaveTokens = useCallback(async () => {
        setEditIntegration(null)
        searchIntegrationsTokens()
    }, [])

    //esse handle somente é para o wpp, seta que esta conectando...
    const handleSaveWpp = useCallback(async () => {
        setEditIntegration(null)

        await searchIntegrationsTokens(false)

        setVerifyWppConectingStatus(true)
    }, []);

    const validate = useCallback((data: IIntegrationsProps['wpp']) => {
        const { instance, status } = data ?? { instance: null, status: null }
        return !!instance && status === 'open'
    }, [])

    const connectingWpp = useCallback((data: IIntegrationsProps['wpp']) => {
        const { status } = data ?? { instance: null, status: null }
        return status === 'connecting'
    }, [])

    // responsavel por verificar se o wpp sincronizou totalmente com a Join Dev
    useEffect(() => {
        if (!verifyWppConectingStatus) return;

        const fetchStatus = async () => {
            try {
                const response = await api.get('/testing-wpp');

                if (response?.data?.message === 'conectado') {
                    notify('WhatsApp conectado', 'success');

                    setIntegrationsTokens({
                        magikey: integrationsTokens['magikey'],
                        stays: integrationsTokens['stays'],
                        wpp: {
                            instance: 'TESTE',
                            status: 'open',
                        }
                    })
                    setVerifyWppConectingStatus(false);
                }
            } catch (error) {
                console.error('Erro ao buscar status:', error);
            }
        };

        fetchStatus();

        const interval = setInterval(fetchStatus, 5000);

        return () => clearInterval(interval);
    }, [verifyWppConectingStatus]);

    useEffect(() => { searchIntegrationsTokens() }, [])

    /*     useEffect(() => {
            const socketInstance =  io(process.env.REACT_APP_API!, {
                transports: ['websocket'],   // força a conexão por WebSocket
                secure: true,                 // garante segurança na conexão wss
                reconnectionAttempts: 5,      // tenta reconectar 5 vezes antes de desistir
                timeout: 10000,               // 10 segundos para tentar conectar
            });
    
            setSocket((atual) => {
                atual?.removeAllListeners();
                atual?.disconnect();
                return socketInstance;
            });
    
            if (socketInstance) {
                socketInstance?.on('wpp-events', async (data) => {
                    if (data?.status === 'connected') notify('Whatsapp conectado', 'success')
                    else notify('Conexão com o Whatsapp perdida', 'alert')
                    await searchIntegrationsTokens()
                });
            }
        }, []); */

    return (
        <DashboardPage>
            <Column style={{ gap: 20, flex: 1 }}>
                <HeaderList
                    textHeader="Integrações"
                    textDescritpion="Integrações disponíveis para conectar"
                    theme={theme}
                    haveBorder
                    loading={loadingSearch}
                    onRefresh={searchIntegrationsTokens}
                />
                <ContentOrLoading loading={loadingSearch} text="Buscando integrações" theme={theme}>

                    <Line style={{ gap: 20, flexWrap: "wrap", justifyContent: "center" }}>
                        {integrationsAvailbles
                            .filter((integration) => integration.name !== 'wpp' || (integration.name === 'wpp' && isHaveWppPermission))
                            .filter((integration) => integration.name !== 'magikey' || (integration.name === 'magikey' && isHaveMagikeyPermission))
                            .map((integration) => (
                                <ContainerIntegrations key={integration.name}>
                                    <IntegrationContainer theme={theme}>
                                        <Column>
                                            {integration.name === 'wpp' && (
                                                <div style={{ minHeight: 19 }}>
                                                    <SwitchContainer open={integration.name === 'wpp' ? validate(integrationsTokens?.[integration.name] as any) : !!integrationsTokens?.[integration.name]}>
                                                        <Switch
                                                            id="tooltip_switch"
                                                            className="custom-switch custom-switch-primary custom-switch-small"
                                                            checked={integration.name === 'wpp' ? validate(integrationsTokens?.[integration.name] as any) : !!integrationsTokens?.[integration.name]}
                                                            onChange={integration.name === 'wpp' ? () => handleChangeStatus(integration.name as 'wpp') : () => { }}
                                                        />
                                                    </SwitchContainer>
                                                </div>
                                            )}

                                            {integration.name === 'stays' && (
                                                <div style={{ minHeight: 19 }} />
                                            )}

                                            {integration.name === 'magikey' && integrationsTokens['magikey']?.apiUrl && (
                                                <div style={{ minHeight: 19 }}>
                                                    <SwitchContainer open={true}>
                                                        <Switch
                                                            id="tooltip_switch"
                                                            className="custom-switch custom-switch-primary custom-switch-small"
                                                            checked={integrationsTokens['magikey']?.active}
                                                            onChange={() => {
                                                                setIntegrationsTokens((prevTokens) => ({
                                                                    ...prevTokens,
                                                                    magikey: {
                                                                        ...prevTokens['magikey'],
                                                                        active: !integrationsTokens['magikey']?.active,
                                                                    }
                                                                }));
                                                                handleUpdateActiveIntegrationMagikey()
                                                            }}
                                                        />
                                                    </SwitchContainer>
                                                </div>
                                            )}

                                            <ContainerIntegrationLogo>
                                                {integration.icon[theme]}
                                                {integration.title}
                                            </ContainerIntegrationLogo>
                                        </Column>

                                        <IntegrationDescription>
                                            {integration.description}
                                        </IntegrationDescription>

                                        <Line style={{ justifyContent: "center", }}>
                                            {!(integration.name === 'wpp' ? validate(integrationsTokens?.[integration.name] as any) : !!integrationsTokens?.[integration.name]) && (
                                                <div>
                                                    <Button
                                                        onClick={() => connectingWpp(integrationsTokens?.[integration?.name] as any) ? {} : handleConectIntegration(integration.name)}
                                                        style={{ gap: 10, alignItems: "center", padding: "10px 16px", minHeight: 41.5, minWidth: 150 }}
                                                        background={inactiveItens[theme]}
                                                        disabled={connectingWpp(integrationsTokens?.[integration?.name] as any)}
                                                        color="#FFF"
                                                        children={(
                                                            <>
                                                                <TbPlugConnected size={20} color="#FFF" />
                                                                {connectingWpp(integrationsTokens?.[integration?.name] as any) ? 'Conectando...' : 'Integrar'}
                                                            </>
                                                        )}
                                                    />
                                                </div>
                                            )}

                                            {(integration.name === 'wpp'
                                                ? validate(integrationsTokens?.[integration.name] as any)
                                                : !!integrationsTokens?.[integration.name]
                                            ) && (integration.name !== 'magikey') && (integration.name !== 'stays') && (
                                                    <div>
                                                        <Button
                                                            onClick={() => { }}
                                                            style={{ gap: 10, cursor: "default", alignItems: "center", padding: "10px 16px", minHeight: 41.5, minWidth: 150 }}
                                                            background={secondary[theme]}
                                                            color="#FFF"
                                                            children={(
                                                                <>
                                                                    <BiCheckCircle size={16} className="connect" />
                                                                    Conectado
                                                                </>
                                                            )}
                                                        />
                                                    </div>
                                                )}

                                            {integration.name === 'magikey' && (
                                                <div>
                                                    {integrationsTokens['magikey']?.apiUrl && (
                                                        <DropdownButton
                                                            className={'dropdown-button-history'}
                                                            options={[
                                                                {
                                                                    id: 2,
                                                                    text: "EDITAR DADOS",
                                                                    onClick: () => handleConectIntegration(integration.name),
                                                                    icon: <FaEdit color={secondary[theme]} size={16} />,
                                                                },
                                                                {
                                                                    id: 3,
                                                                    text: "DESCONECTAR",
                                                                    onClick: () => handleDeleteIntegrationMagikey(),
                                                                    icon: <TbPlugConnected color={secondary[theme]} size={16} />,
                                                                },
                                                            ]}
                                                            icon={<BiCheckCircle size={16} color="#FFF" />}
                                                            loading={false}
                                                            main_option={{ text: "Conectado", id: 1 }}
                                                            onClick={() => handleConectIntegration(integration.name)}
                                                            theme={theme}
                                                            zIndex={900}
                                                        />
                                                    )}
                                                </div>
                                            )}

                                            {integration.name === 'stays' && (
                                                <div>
                                                    {integrationsTokens['stays']?.apiUrl && (
                                                        <DropdownButton
                                                            className={'dropdown-button-history2'}
                                                            options={[
                                                                {
                                                                    id: 3,
                                                                    text: "DESCONECTAR",
                                                                    onClick: () => setIsModalDeleteStays(true),
                                                                    icon: <TbPlugConnected color={secondary[theme]} size={16} />,
                                                                },
                                                            ]}
                                                            icon={<BiCheckCircle size={16} color="#FFF" />}
                                                            loading={false}
                                                            main_option={{ text: "Conectado", id: 2 }}
                                                            onClick={() => handleConectIntegration(integration.name)}
                                                            theme={theme}
                                                            zIndex={900}
                                                        />
                                                    )}
                                                </div>
                                            )}

                                        </Line>
                                    </IntegrationContainer>
                                </ContainerIntegrations>
                            ))}
                    </Line>

                </ContentOrLoading>
            </Column>

            <ModalLoading
                loading={loadingEdit}
                theme={theme}
            />

            {editIntegration === "wpp" && (
                <ModalWppConection
                    onCancel={handleSaveTokens}
                    onSave={handleSaveWpp}
                />
            )}

            {editIntegration === "magikey" && (
                <ModalMagikeyConection
                    onCancel={() => setEditIntegration(null)}
                    onSave={handleSaveTokens}
                    defaultId={integrationsTokens?.magikey?.integrationId}
                />
            )}

            {isModalDeleteStays && (
                <ModalDeleteStaysConection
                    onCancel={() => setIsModalDeleteStays(false)}
                    onConfirm={handleDeleteIntegrationStays}
                    loading={loadingEdit}

                />
            )}

            {editIntegration === "stays" && (
                <ModalStaysConection
                    onCancel={() => setEditIntegration(null)}
                    onSave={handleSaveTokens}
                    defaultId={integrationsTokens?.stays?.integrationId}
                />
            )}
        </DashboardPage >
    )
}